import * as React from 'react';
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { handleEntraRedirect, isEntraAuthenticated } from '@app/utils/entraAuth';

const AuthCallback: React.FunctionComponent = () => {
  const navigate = useNavigate();
  const hasHandledRef = useRef(false);

  useEffect(() => {
    const handleCallback = async () => {
      try {
        if (hasHandledRef.current) {
          return;
        }
        hasHandledRef.current = true;

        await handleEntraRedirect();
        const authenticated = await isEntraAuthenticated();
        if (!authenticated) {
          throw new Error('Microsoft sign-in did not complete');
        }

        try {
          const storedPath = window.sessionStorage.getItem('postAuthRedirectPath');
          if (storedPath && storedPath.startsWith('/')) {
            window.sessionStorage.removeItem('postAuthRedirectPath');
            navigate(storedPath, { replace: true });
            return;
          }
        } catch (e) {
          console.error('Failed to read post-auth redirect path', e);
        }

        navigate('/requests', { replace: true });
      } catch (error) {
        console.error('Authentication error:', error);
        navigate('/', { replace: true });
      }
    };

    handleCallback();
  }, [navigate]);

  return null;
};

export { AuthCallback };
